module.exports = __webpack_public_path__ + "images/category_lp/bike/store_images/3_b268ab09186b2e67f0ecf3dcd3232cc9.jpg";